export default "__VITE_ASSET__B6LnJIO9__"